var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, placeholderState, ref, saveRecentSearch, setSiteCookies, storeGeolocationData, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, storeGeolocationData = ref.storeGeolocationData;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    this.render();
    this.bind();
    this.country = document.head.getAttribute('data-country') || 'US';
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /*
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /*
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, value;
    data = $trigger.data();
    value = data.value, lat = data.lat, lng = data.lng, division = data.division;
    data = {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /*
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeolocation, enableRecentSearches, experiments, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments);
    if (options != null) {
      enableGeolocation = options['enableGeolocation'] || options['LS-2613-current-location'];
      enableBetterUx = options['LS-2685-location-field-ux'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeolocation: enableGeolocation,
      enableRecentSearches: enableRecentSearches,
      enableBetterUx: enableBetterUx,
      experiments: experiments
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if (Groupon.LS.experiments['enableRecentLocations']) {
      saveRecentSearch(locSearch, 'location');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          Groupon.Utils.trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              Groupon.Utils.trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        Groupon.Utils.trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        Groupon.Utils.trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    Groupon.Utils.trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    Groupon.Utils.trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = _.extend(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      data = _.extend(data, {
        query: query,
        hasLocCookie: true
      });
      storeGeolocationData(current_location, currentLocationData);
      return this.redirectTo(data);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return Groupon.Utils.trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data) {
    var address, closestDivision, division, hasLocCookie, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division, hasLocCookie = data.hasLocCookie;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    Groupon.Utils.trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvc2VhcmNoX2Jhci9mcm9udGVuZC92aWV3cy9zZWFyY2hfYmFyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3NlYXJjaF9iYXIvZnJvbnRlbmQvdmlld3Mvc2VhcmNoX2Jhci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSx5VEFBQTtFQUFBOzs7QUFBQSxPQUFBLENBQVEseURBQVI7O0FBQ0EsUUFBQSxHQUFXLE9BQUEsQ0FBUSxnRUFBUjs7QUFDWCxRQUFBLEdBQVcsT0FBQSxDQUFRLHVFQUFSOztBQUNYLGNBQUEsR0FBaUIsT0FBQSxDQUFRLGdFQUFSOztBQUNqQixPQUFPLENBQUMsaUJBQVIsR0FBNEIsT0FBQSxDQUFRLG1FQUFSOztBQUU1QixVQUFBLEdBQWdCLE9BQUEsQ0FBUSxpRUFBUjs7QUFDaEIsV0FBQSxHQUFnQixPQUFBLENBQVEsa0VBQVI7O0FBQ2hCLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLDJEQUFSOztBQUNoQixTQUFBLEdBQWdCLE9BQUEsQ0FBUSwrREFBUjs7QUFFZCxtQkFBcUIsT0FBQSxDQUFRLCtFQUFSOztBQUVyQixnQkFBa0IsT0FBQSxDQUFRLGdFQUFSOztBQUVsQixtQkFBcUIsT0FBQSxDQUFRLDhEQUFSOztBQUV2QixNQVFJLE9BQUEsQ0FBUSx3RUFBUixDQVJKLEVBQUUsdUNBQUYsRUFDRSxxREFERixFQUVFLCtDQUZGLEVBR0UsbURBSEYsRUFJRSwrQ0FKRixFQUtFLCtCQUxGLEVBTUUsdUJBTkYsRUFPRTs7QUFJRixNQUFNLENBQUMsT0FBUCxHQUF1QjtBQUNyQixNQUFBOztFQUFBLElBQUEsR0FBTyxRQUFRLENBQUMsSUFBVCxJQUFpQixRQUFRLENBQUMsb0JBQVQsQ0FBOEIsTUFBOUIsQ0FBc0MsQ0FBQSxDQUFBOztFQUM5RCxPQUFBLEdBQVUsWUFBQSxHQUFlOztFQUVaLHVCQUFDLEdBQUQ7QUFDWCxRQUFBO0lBRGEsTUFBRDs7Ozs7Ozs7Ozs7OztJQUNaLElBQUMsQ0FBQSxLQUFELEdBQVM7SUFDVCxJQUFDLENBQUEsR0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLEtBQUQsR0FBYSxDQUFBLENBQUUsUUFBUSxDQUFDLElBQVg7SUFDYixJQUFDLENBQUEsT0FBRCxHQUFhLEdBQUcsQ0FBQyxJQUFKLENBQVMsb0JBQVQ7SUFDYixJQUFDLENBQUEsU0FBRCxHQUFhLEdBQUcsQ0FBQyxJQUFKLENBQVMsV0FBVDtJQUNiLElBQUMsQ0FBQSxPQUFELEdBQWEsR0FBRyxDQUFDLElBQUosQ0FBUyxTQUFUO0lBQ2IsSUFBQyxDQUFBLGlCQUFELEdBQXFCLENBQUEsQ0FBRSxvQkFBRjtJQUVyQixJQUFDLENBQUEsYUFBRCxHQUFpQixDQUFBLENBQUUsbUJBQUY7SUFDakIsSUFBQyxDQUFBLHFCQUFELEdBQXlCLENBQUEsQ0FBRSw0QkFBRjtJQUV6QixJQUFDLENBQUEsZUFBRCxHQUFtQixDQUFBLENBQUUsa0JBQUY7SUFDbkIsSUFBQyxDQUFBLFFBQUQsR0FBWSxDQUFBLENBQUUsa0JBQUY7SUFDWixJQUFDLENBQUEsYUFBRCxHQUFpQixDQUFBLENBQUUsMEJBQUY7SUFFakIsSUFBQyxDQUFBLE1BQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxJQUFELENBQUE7SUFDQSxJQUFDLENBQUEsT0FBRCxHQUFXLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixjQUEzQixDQUFBLElBQThDO0lBQ3pELFlBQUEsR0FBZSxPQUFPLENBQUMsRUFBRSxDQUFDO0lBRTFCLElBQUMsQ0FBQSxlQUFELEdBQW1CLFFBQVEsQ0FBQyxrQkFBVCxDQUFBO0VBckJSOzswQkF1QmIsSUFBQSxHQUFNLFNBQUE7SUFFSixJQUFDLENBQUEsS0FBSyxDQUFDLEVBQVAsQ0FBVSxRQUFWLEVBQW9CLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxDQUFELEVBQUksS0FBSjtRQU1sQixDQUFDLENBQUMsS0FBRixHQUFVO2VBQ1YsS0FBQyxDQUFBLFlBQUQsQ0FBYyxDQUFkO01BUGtCO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFwQjs7QUFTQTs7O0lBR0EsSUFBQyxDQUFBLE9BQU8sQ0FBQyxFQUFULENBQ0U7TUFBQSxlQUFBLEVBQWlCLENBQUEsU0FBQSxLQUFBO2VBQUEsU0FBQyxDQUFEO0FBQ2YsY0FBQTtVQUFBLEVBQUEsR0FBSyxDQUFDLENBQUM7VUFDUCxnQkFBZ0IsQ0FBQyxNQUFqQixDQUF3QixDQUFBLENBQUUsRUFBRixDQUF4QjtpQkFDQSxLQUFDLENBQUEsU0FBUyxDQUFDLHFCQUFYLENBQWlDLENBQWpDLEVBQW9DLEVBQUUsQ0FBQyxJQUF2QztRQUhlO01BQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFqQjtNQUtBLE9BQUEsRUFBUyxDQUFBLFNBQUEsS0FBQTtlQUFBLFNBQUMsQ0FBRDtBQUNQLGNBQUE7QUFBQSxrQkFBTyxhQUFBLENBQWMsQ0FBZCxDQUFQO0FBQUEsaUJBQ08sT0FEUDtjQUlJLElBQUcsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxJQUFoQixLQUF3QixVQUEzQjtnQkFDRSxDQUFDLENBQUMsY0FBRixDQUFBO2dCQUVBLElBQUcsQ0FBQyxNQUFBLEdBQVMsS0FBQyxDQUFBLFNBQVMsQ0FBQyxVQUFVLENBQUMsSUFBdEIsQ0FBMkIsNEJBQTNCLENBQVYsQ0FBbUUsQ0FBQyxNQUF2RTtrQkFDRSxNQUFNLENBQUMsT0FBUCxDQUFlLE9BQWYsRUFERjtpQkFBQSxNQUFBO2tCQUdFLEtBQUMsQ0FBQSxTQUFTLENBQUMsSUFBWCxDQUFBO2tCQUNBLEtBQUMsQ0FBQSxLQUFLLENBQUMsT0FBUCxDQUFlLFFBQWYsRUFBeUIsUUFBekIsRUFKRjtpQkFIRjs7QUFIRztBQURQLGlCQWFPLEtBYlA7Y0FlSSxLQUFDLENBQUEsU0FBUyxDQUFDLElBQVgsQ0FBQTtBQUZHO0FBYlAsaUJBaUJPLFdBakJQO2NBbUJJLEtBQUMsQ0FBQSxpQkFBaUIsQ0FBQyxJQUFuQixDQUF3QixHQUF4QixDQUE0QixDQUFDLEVBQTdCLENBQWdDLENBQWhDLENBQWtDLENBQUMsS0FBbkMsQ0FBQTtjQUNBLEtBQUMsQ0FBQSxpQkFBaUIsQ0FBQyxJQUFuQixDQUF3QixrQkFBeEIsQ0FBMkMsQ0FBQyxXQUE1QyxDQUF3RCwyQkFBeEQ7Y0FDQSxDQUFDLENBQUMsY0FBRixDQUFBO0FBckJKO1FBRE87TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBTFQ7TUE4QkEsT0FBQSxFQUFTLENBQUEsU0FBQSxLQUFBO2VBQUEsU0FBQyxDQUFEO0FBQ1AsY0FBQTtVQUFBLEtBQUMsQ0FBQSxLQUFLLENBQUMsVUFBUCxDQUFrQixPQUFsQjtVQUNBLElBQUEsQ0FBTyxDQUFDLE9BQUEsR0FBVSxDQUFBLENBQUUsQ0FBQyxDQUFDLGFBQUosQ0FBa0IsQ0FBQyxNQUFuQixDQUFBLENBQVgsQ0FBdUMsQ0FBQyxRQUF4QyxDQUFpRCxlQUFqRCxDQUFQO1lBQ0UsS0FBQyxDQUFBLEtBQUssQ0FBQyxJQUFQLENBQVksWUFBWixDQUF5QixDQUFDLFdBQTFCLENBQXNDLGVBQXRDO21CQUNBLE9BQU8sQ0FBQyxRQUFSLENBQWlCLGVBQWpCLEVBRkY7O1FBRk87TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBOUJUO01Bb0NBLFFBQUEsRUFBVSxDQUFBLFNBQUEsS0FBQTtlQUFBLFNBQUMsQ0FBRDtBQUNSLGNBQUE7VUFBQSxLQUFDLENBQUEsS0FBSyxDQUFDLFVBQVAsQ0FBa0IsUUFBbEI7VUFDQSxLQUFBLEdBQVEsQ0FBQSxDQUFFLENBQUMsQ0FBQyxhQUFKO1VBQ1IsS0FBSyxDQUFDLE1BQU4sQ0FBQSxDQUFjLENBQUMsV0FBZixDQUEyQixlQUEzQjtVQUNBLGdCQUFnQixDQUFDLE1BQWpCLENBQXdCLEtBQXhCO1VBR0EsSUFBRyxDQUFJLENBQUEsQ0FBRSxZQUFGLENBQWUsQ0FBQyxNQUF2QjtZQUNFLFlBQUEsR0FBZSxLQUFDLENBQUEsT0FBTyxDQUFDLE1BQVQsQ0FBZ0IsT0FBaEI7WUFDZixTQUFBLEdBQVksS0FBQyxDQUFBLFNBQVMsQ0FBQyxNQUFYLENBQWtCLE9BQWxCO1lBRVosSUFBRyxDQUFJLFlBQVksQ0FBQyxFQUFiLENBQWdCLGdCQUFoQixDQUFKLElBQTBDLENBQUksU0FBUyxDQUFDLEVBQVYsQ0FBYSxnQkFBYixDQUFqRDtxQkFDRSxZQUFZLENBQUMsUUFBYixDQUFzQixlQUF0QixFQURGO2FBSkY7O1FBUFE7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBcENWO0tBREY7O0FBbURBOzs7SUFHQSxJQUFDLENBQUEsS0FBSyxDQUFDLEVBQVAsQ0FBVSxPQUFWLEVBQW1CLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQTtlQUNqQixLQUFDLENBQUEsU0FBUyxDQUFDLElBQVgsQ0FBQTtNQURpQjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBbkI7SUFJQSxDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsR0FBVixDQUFjLE1BQWQsRUFBc0IsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFBO2VBQ3BCLEtBQUMsQ0FBQSxLQUFLLENBQUMsSUFBUCxDQUFZLE9BQVosQ0FBb0IsQ0FBQyxJQUFyQixDQUEwQixTQUFBO2lCQUN4QixnQkFBZ0IsQ0FBQyxNQUFqQixDQUF3QixDQUFBLENBQUUsSUFBRixDQUF4QjtRQUR3QixDQUExQjtNQURvQjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBdEI7O0FBSUE7OztJQUdBLElBQUMsQ0FBQSxpQkFBaUIsQ0FBQyxFQUFuQixDQUFzQixPQUF0QixFQUErQixHQUEvQixFQUFvQyxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsQ0FBRDtRQUNsQyxJQUFHLENBQUEsQ0FBRSxDQUFDLENBQUMsYUFBSixDQUFrQixDQUFDLFFBQW5CLENBQTRCLGtCQUE1QixDQUFIO1VBQ0UsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtVQUNBLEtBQUMsQ0FBQSxLQUFLLENBQUMsT0FBUCxDQUFlLFFBQWYsRUFBeUIsV0FBekIsRUFGRjtTQUFBLE1BQUE7VUFJRSxLQUFDLENBQUEsYUFBRCxDQUFlLENBQWYsRUFKRjs7TUFEa0M7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQXBDO1dBUUEsSUFBQyxDQUFBLGlCQUFpQixDQUFDLEVBQW5CLENBQXNCLFNBQXRCLEVBQWlDLEdBQWpDLEVBQXNDLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxDQUFEO0FBQ3BDLFlBQUE7UUFBQSxDQUFDLENBQUMsY0FBRixDQUFBO1FBQ0EsT0FBQSxHQUFVLEtBQUMsQ0FBQTtRQUNYLFFBQUEsR0FBVyxPQUFPLENBQUMsSUFBUixDQUFhLEdBQWI7QUFFWCxnQkFBTyxhQUFBLENBQWMsQ0FBZCxDQUFQO0FBQUEsZUFDTyxPQURQO1lBRUksR0FBQSxHQUFNLENBQUEsQ0FBRSxDQUFDLENBQUMsYUFBSjtZQUNOLElBQUcsR0FBRyxDQUFDLFFBQUosQ0FBYSxrQkFBYixDQUFIO3FCQUNFLEdBQUcsQ0FBQyxPQUFKLENBQVksT0FBWixFQURGO2FBQUEsTUFBQTtxQkFHRSxLQUFDLENBQUEsYUFBRCxDQUFlLENBQWYsRUFIRjs7QUFGRztBQURQLGVBUU8sU0FSUDttQkFTSSxRQUFRLENBQUMsRUFBVCxDQUFZLFFBQVEsQ0FBQyxLQUFULENBQWUsQ0FBQyxDQUFDLGFBQWpCLENBQUEsR0FBa0MsQ0FBOUMsQ0FBZ0QsQ0FBQyxLQUFqRCxDQUFBO0FBVEosZUFXTyxXQVhQO21CQVlJLFFBQVEsQ0FBQyxFQUFULENBQVksUUFBUSxDQUFDLEtBQVQsQ0FBZSxDQUFDLENBQUMsYUFBakIsQ0FBQSxHQUFrQyxDQUE5QyxDQUFnRCxDQUFDLEtBQWpELENBQUE7QUFaSjtZQWVJLElBQUcsYUFBQSxDQUFjLENBQWQsQ0FBQSxLQUFvQixLQUFwQixJQUE4QixPQUFPLENBQUMsRUFBUixDQUFXLGtCQUFYLENBQWpDO3FCQUNFLEtBQUMsQ0FBQSxZQUFELENBQWMsQ0FBZCxFQURGO2FBQUEsTUFBQTtxQkFLRSxLQUFDLENBQUEsaUJBQWlCLENBQUMsSUFBbkIsQ0FBd0IsT0FBeEIsQ0FBZ0MsQ0FBQyxLQUFqQyxDQUFBLEVBTEY7O0FBZko7TUFMb0M7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQXRDO0VBdkZJOzs7QUFrSE47Ozs7OzswQkFLQSxXQUFBLEdBQWEsU0FBQyxRQUFEO0lBQ1gsZ0JBQWdCLENBQUMsR0FBakIsQ0FBcUIsSUFBQyxDQUFBLE9BQXRCLEVBQStCLE1BQS9CO0lBQ0EsSUFBQyxDQUFBLE9BQU8sQ0FBQyxHQUFULENBQWEsUUFBUSxDQUFDLElBQVQsQ0FBYyxPQUFkLENBQWI7RUFGVzs7O0FBS2I7Ozs7OzswQkFLQSxvQkFBQSxHQUFzQixTQUFDLFFBQUQ7QUFDcEIsUUFBQTtJQUFBLElBQUEsR0FBTyxRQUFRLENBQUMsSUFBVCxDQUFBO0lBQ0wsa0JBQUYsRUFBUyxjQUFULEVBQWMsY0FBZCxFQUFtQjtJQUNuQixJQUFBLEdBQU87TUFBQyxHQUFBLEVBQUssR0FBRyxDQUFDLFFBQUosQ0FBQSxDQUFOO01BQXNCLEdBQUEsRUFBSyxHQUFHLENBQUMsUUFBSixDQUFBLENBQTNCO01BQTJDLFVBQUEsUUFBM0M7TUFBcUQsUUFBQSxFQUFVLEtBQS9EOztJQUNQLElBQUMsQ0FBQSxTQUFTLENBQUMsR0FBWCxDQUFlLEtBQWYsQ0FBcUIsQ0FBQyxJQUF0QixDQUEyQixJQUEzQjtFQUpvQjs7O0FBT3RCOzs7Ozs7OzBCQU1BLGFBQUEsR0FBZSxTQUFDLENBQUQ7QUFDYixRQUFBO0lBQUEsUUFBQSxHQUFXLENBQUEsQ0FBRSxDQUFDLENBQUMsYUFBSjtJQUNYLE9BQUEsR0FBVSxJQUFDLENBQUE7SUFDWCxJQUFBLENBQU8sUUFBUSxDQUFDLFFBQVQsQ0FBa0IsVUFBQSxHQUFhLGlCQUEvQixDQUFQO01BRUUsT0FBTyxDQUFDLElBQVIsQ0FBYSxrQkFBYixDQUFnQyxDQUFDLFdBQWpDLENBQTZDLFVBQTdDLEVBRkY7O0lBSUEsSUFBRyxPQUFPLENBQUMsUUFBUixDQUFpQixvQkFBakIsQ0FBSDtNQUNFLEtBQUEsR0FBUTtNQUNSLElBQUMsQ0FBQSxvQkFBRCxDQUFzQixRQUF0QixFQUZGO0tBQUEsTUFBQTtNQUlFLEtBQUEsR0FBUTtNQUNSLElBQUMsQ0FBQSxXQUFELENBQWEsUUFBYixFQUxGOztJQU9BLElBQUMsQ0FBQSxLQUFLLENBQUMsT0FBUCxDQUFlLFFBQWYsRUFBeUIsS0FBekI7RUFkYTs7MEJBaUJmLFlBQUEsR0FBYyxTQUFDLENBQUQ7SUFDWixJQUFDLENBQUEsb0JBQUQsQ0FBc0IsQ0FBQSxDQUFFLENBQUMsQ0FBQyxhQUFKLENBQXRCO0lBQ0EsSUFBQyxDQUFBLGlCQUFpQixDQUFDLElBQW5CLENBQUE7SUFDQSxJQUFDLENBQUEsU0FBUyxDQUFDLEtBQVgsQ0FBQTtFQUhZOzswQkFNZCxNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxPQUF5QixPQUFPLENBQUMsRUFBakMsRUFBQyxzQkFBRCxFQUFVOztNQUNWLFVBQVc7O0lBQ1gsT0FBQSxHQUFVLENBQUMsQ0FBQyxNQUFGLENBQVMsRUFBVCxFQUFhLE9BQWIsRUFBc0IsV0FBdEI7SUFDVixJQUFHLGVBQUg7TUFDRSxpQkFBQSxHQUF1QixPQUFRLENBQUEsbUJBQUEsQ0FBUixJQUFnQyxPQUFRLENBQUEsMEJBQUE7TUFDL0QsY0FBQSxHQUF1QixPQUFRLENBQUEsMkJBQUE7TUFDL0Isb0JBQUEsR0FBdUIsS0FIekI7O0lBS0EsSUFBQyxDQUFBLFNBQUQsR0FBaUIsSUFBQSxTQUFBLENBQVU7TUFDekIsR0FBQSxFQUFLLElBQUMsQ0FBQSxHQURtQjtNQUV6QixVQUFBLEVBQVksSUFBQyxDQUFBLGlCQUZZO01BR3pCLFNBQUEsRUFDRTtRQUFBLE1BQUEsMkNBQTJCLENBQUUsY0FBN0I7UUFDQSxRQUFBLDJDQUEyQixDQUFFLGtCQUQ3QjtPQUp1QjtNQU16QixtQkFBQSxpQkFOeUI7TUFPekIsc0JBQUEsb0JBUHlCO01BUXpCLGdCQUFBLGNBUnlCO01BU3pCLGFBQUEsV0FUeUI7S0FBVjtJQVlqQixJQUFDLENBQUEsYUFBRCxHQUFxQixJQUFBLGFBQUEsQ0FBYztNQUFDLEdBQUEsRUFBSyxJQUFDLENBQUEsS0FBUDtNQUFjLFdBQUEsRUFBYSxJQUFDLENBQUEsaUJBQTVCO01BQStDLEdBQUEsRUFBSyxJQUFDLENBQUEsR0FBckQ7TUFBMEQsZ0JBQUEsY0FBMUQ7S0FBZDtJQUVyQixJQUFDLENBQUEsVUFBRCxHQUFrQixJQUFBLFVBQUEsQ0FBVztNQUMzQixFQUFBLEVBQUksSUFBQyxDQUFBLEtBRHNCO01BRTNCLEdBQUEsRUFBSyxJQUFDLENBQUEsR0FGcUI7S0FBWDtJQUtsQixJQUFDLENBQUEsV0FBRCxHQUFtQixJQUFBLFdBQUEsQ0FBWTtNQUM3QixFQUFBLEVBQUksSUFBQyxDQUFBLEtBRHdCO01BRTdCLEdBQUEsRUFBSyxJQUFDLENBQUEsR0FGdUI7S0FBWjtXQUtuQixJQUFDLENBQUEseUJBQUQsQ0FBQTtFQWpDTTs7MEJBbUNSLFFBQUEsR0FBVSxTQUFBO0FBQ1IsUUFBQTtJQUFBLFFBQUEsR0FBVyxJQUFDLENBQUEsT0FBTyxDQUFDLElBQVQsQ0FBYyxXQUFkLENBQUEsSUFBOEI7SUFDekMsT0FBQSx3RUFBNEIsQ0FBRSxJQUFwQixDQUFBLENBQTBCLENBQUMsS0FBM0IsQ0FBaUMsQ0FBakMsRUFBb0MsUUFBcEM7SUFDVixJQUFBLENBQWUsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxPQUFWLENBQWY7YUFBQSxRQUFBOztFQUhROzswQkFLVixVQUFBLEdBQVksU0FBQyxLQUFEO0FBQ1YsUUFBQTtJQUFBLGVBQUEsK0NBQWtDLENBQUU7SUFDcEMsVUFBQSxHQUFhLElBQUMsQ0FBQSxRQUFELENBQUE7SUFDYixTQUFBLEdBQVksSUFBQyxDQUFBLFdBQVcsQ0FBQyxHQUFiLENBQUE7SUFDWixJQUFBLENBQUEsQ0FBYyxvQkFBQSxJQUFlLG1CQUE3QixDQUFBO0FBQUEsYUFBQTs7SUFHQSxJQUF3QyxrQkFBeEM7TUFBQSxnQkFBQSxDQUFpQixVQUFqQixFQUE2QixNQUE3QixFQUFBOztJQUdBLElBQTJDLE9BQU8sQ0FBQyxFQUFFLENBQUMsV0FBWSxDQUFBLHVCQUFBLENBQWxFO01BQUEsZ0JBQUEsQ0FBaUIsU0FBakIsRUFBNEIsVUFBNUIsRUFBQTs7SUFJQSxJQUFHLENBQUMsYUFBQSxHQUFnQixDQUFBLENBQUUsc0NBQUYsQ0FBakIsQ0FBMkQsQ0FBQyxNQUEvRDtNQUNFLElBQUEsR0FBTyxDQUFDLENBQUMsSUFBRixDQUFPLGFBQWEsQ0FBQyxJQUFkLENBQUEsQ0FBUCxFQUE2QixLQUE3QixFQUFvQyxLQUFwQyxFQURUO0tBQUEsTUFBQTtNQUdFLE9BQUEsR0FBVSxJQUFDLENBQUEsU0FBUyxDQUFDLElBQVgsQ0FBQTtNQUtWLElBQUcsT0FBTyxDQUFDLE1BQVIsSUFBbUIsS0FBQSxLQUFTLE1BQS9CO1FBQThDLEtBQUEsR0FBUSxTQUF0RDs7QUFFQSxjQUFPLEtBQVA7QUFBQSxhQUNPLGNBRFA7QUFBQSxhQUN1QixRQUR2QjtVQUVJLElBQUEsR0FBTyxDQUFDLENBQUMsSUFBRixDQUFPLE9BQVAsRUFBZ0IsS0FBaEIsRUFBdUIsS0FBdkIsRUFBOEIsaUJBQTlCO0FBRFk7QUFEdkI7VUFJSSxJQUFBLEdBQU8sQ0FBQyxDQUFDLElBQUYsVUFBTyxDQUFBLE9BQUEsRUFBUyxLQUFULEVBQWdCLEtBQWhCLEVBQXVCLGlCQUFtQixTQUFBLFdBQUEsUUFBQSxDQUFBLENBQWpEO1VBQ1AsYUFBQSx1RUFBNEQsQ0FBRTtVQUM5RCxJQUFHLGFBQUEsSUFBa0IsSUFBSSxDQUFDLEdBQUwsQ0FBQSxDQUFBLDhCQUFhLGVBQWUsQ0FBRSxtQkFBOUIsR0FBMEMsYUFBL0Q7WUFDRSxLQUFBLEdBQVEsWUFEVjs7QUFOSixPQVZGOztJQW1CQSxJQUFHLENBQUksZUFBSixJQUF1QixDQUFJLElBQUksQ0FBQyxlQUFuQztNQUNFLElBQUksQ0FBQyxlQUFMLDJDQUF1QyxDQUFFLFlBRDNDOztXQUdBO01BQ0UsSUFBQSxFQUFNLENBQUMsQ0FBQyxNQUFGLENBQVMsSUFBVCxFQUFlO1FBQUMsT0FBQSxFQUFTLFNBQVY7UUFBcUIsS0FBQSxFQUFPLE9BQTVCO09BQWYsQ0FEUjtNQUVFLE9BQUEsS0FGRjs7RUFwQ1U7OzBCQXlDWixVQUFBLEdBQVksU0FBQyxJQUFEOztNQUFDLE9BQU87O0lBQ2xCLElBQUcsSUFBSDtNQUNFLElBQUMsQ0FBQSxhQUFhLENBQUMsSUFBZixDQUFvQixVQUFwQixFQUFnQyxJQUFoQyxDQUFxQyxDQUFDLFdBQXRDLENBQWtELHVCQUFsRCxDQUEwRSxDQUFDLFFBQTNFLENBQW9GLGtCQUFwRixFQURGO0tBQUEsTUFBQTtNQUdFLElBQUMsQ0FBQSxhQUFhLENBQUMsSUFBZixDQUFvQixVQUFwQixFQUFnQyxLQUFoQyxDQUFzQyxDQUFDLFdBQXZDLENBQW1ELGtCQUFuRCxDQUFzRSxDQUFDLFFBQXZFLENBQWdGLHVCQUFoRixFQUhGOztFQURVOzswQkFPWixZQUFBLEdBQWMsU0FBQyxDQUFEO0FBQ1osUUFBQTtJQUFBLENBQUMsQ0FBQyxjQUFGLENBQUE7SUFFQSxLQUFBLEdBQVEsQ0FBQyxDQUFDO0lBQ1YsT0FBZ0IsSUFBQyxDQUFBLFVBQUQsQ0FBWSxLQUFaLENBQWhCLEVBQUMsZ0JBQUQsRUFBTztJQUNQLElBQWMsWUFBZDtBQUFBLGFBQUE7O0lBRUEsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0lBRUEsSUFBQyxDQUFBLFNBQVMsQ0FBQyxVQUFYLENBQXNCLE9BQXRCLENBQThCLENBQUMsUUFBL0IsQ0FBd0MsdUJBQXhDO0lBQ0EsSUFBQyxDQUFBLGVBQWUsQ0FBQyxVQUFqQixDQUE0QixPQUE1QjtJQUdBLFdBQUEsR0FBYyx1QkFBQSxDQUF3QixJQUFJLENBQUMsS0FBN0IsRUFBb0MsSUFBSSxDQUFDLE9BQXpDO0lBQ2QsSUFBRyxtQkFBSDtBQUNFLGFBQU8sT0FBTyxDQUFDLGlCQUFSLENBQTBCLFdBQTFCLEVBRFQ7O0FBR0EsWUFBTyxLQUFQO0FBQUEsV0FDTyxXQURQO1FBRUksSUFBSSxDQUFDLGVBQUwsR0FBdUI7UUFDdkIsRUFBQSxHQUFLLElBQUMsQ0FBQTtBQUZIO0FBRFAsV0FJTyxjQUpQO1FBS0ksRUFBQSxHQUFLLElBQUMsQ0FBQTtRQUNOLFFBQVEsQ0FBQyxxQkFBVCxDQUErQixrQkFBL0I7QUFGRztBQUpQLFdBT08sUUFQUDtRQVFJLEVBQUEsR0FBSyxJQUFDLENBQUE7UUFDTixRQUFRLENBQUMscUJBQVQsQ0FBK0Isa0JBQS9CO0FBRkc7QUFQUDtRQVdJLEVBQUEsR0FBSyxJQUFDLENBQUE7QUFYVjtXQVlBLEVBQUEsQ0FBRyxJQUFIO0VBN0JZOzswQkErQmQseUJBQUEsR0FBMkIsU0FBQTtXQUN6QixJQUFDLENBQUEsS0FBSyxDQUFDLEVBQVAsQ0FBVSxtQkFBVixFQUErQixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsQ0FBRDtRQUc3QixJQUFHLENBQUMsQ0FBQyxNQUFGLElBQWEsQ0FBQSxDQUFFLENBQUMsQ0FBQyxhQUFKLENBQWtCLENBQUMsSUFBbkIsQ0FBd0IsQ0FBQyxDQUFDLE1BQTFCLENBQWlDLENBQUMsTUFBbEQ7VUFDRSxPQUFPLENBQUMsS0FBSyxDQUFDLFVBQWQsQ0FBeUIsbUJBQXpCO1VBQ0EsS0FBQyxDQUFBLEtBQUssQ0FBQyxHQUFQLENBQVcsbUJBQVg7aUJBQ0EsS0FBQyxDQUFBLEtBQUssQ0FBQyxFQUFQLENBQVUsb0JBQVYsRUFBZ0MsU0FBQyxDQUFEO1lBRzlCLElBQUcsQ0FBSSxDQUFBLENBQUUsQ0FBQyxDQUFDLGFBQUosQ0FBa0IsQ0FBQyxJQUFuQixDQUF3QixDQUFDLENBQUMsYUFBMUIsQ0FBd0MsQ0FBQyxNQUFoRDtjQUNFLE9BQU8sQ0FBQyxLQUFLLENBQUMsVUFBZCxDQUF5QixvQkFBekI7Y0FDQSxLQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVyxvQkFBWDtxQkFDQSxLQUFDLENBQUEseUJBQUQsQ0FBQSxFQUhGOztVQUg4QixDQUFoQyxFQUhGOztNQUg2QjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBL0I7RUFEeUI7OzBCQWUzQixnQkFBQSxHQUFrQixTQUFBO0lBQ2hCLElBQUMsQ0FBQSxTQUFTLENBQUMsVUFBWCxDQUFzQixRQUF0QjtXQUNBLElBQUMsQ0FBQSxlQUFlLENBQUMsVUFBakIsQ0FBNEIsUUFBNUI7RUFGZ0I7OzBCQU9sQix1QkFBQSxHQUF5QixTQUFBO0FBQ3ZCLFFBQUE7SUFBQSxRQUFRLENBQUMscUJBQVQsQ0FBK0Isa0JBQS9CO0lBQ0EsUUFBUSxDQUFDLGtCQUFULENBQTRCLG9CQUE1QixFQUFrRCxLQUFsRDtJQUVBLElBQUcsWUFBWSxDQUFDLE1BQU0sQ0FBQyxlQUFwQixLQUF1QyxJQUFDLENBQUEsU0FBUyxDQUFDLEdBQVgsQ0FBQSxDQUF2QyxJQUE0RCxtQ0FBL0Q7TUFDRyxjQUFELEVBQU0sY0FBTixFQUFXO01BQ1gsT0FBQSxHQUFVO1FBQ1IsT0FBQSxFQUFTLElBREQ7UUFFUixLQUFBLEdBRlE7UUFHUixLQUFBLEdBSFE7UUFJUixlQUFBLEVBQWlCLENBQUEsU0FBQSxLQUFBO2lCQUFBLFNBQUMsR0FBRDtBQUNmLGdCQUFBO1lBRGlCLGVBQUQ7WUFDaEIsS0FBQyxDQUFBLFNBQVMsQ0FBQyxJQUFYLENBQWdCLFlBQWhCLENBQTZCLENBQUMsR0FBOUIsQ0FBa0MsWUFBWSxDQUFDLFlBQS9DO21CQUNBLFFBQVEsQ0FBQyxrQkFBVCxDQUE0QixZQUE1QjtVQUZlO1FBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUpUO1FBT1IsYUFBQSxFQUFlLFNBQUEsR0FBQSxDQVBQOzthQVVWLElBQUMsQ0FBQSxlQUFELENBQWlCLE9BQWpCLEVBWkY7O0VBSnVCOzswQkFrQnpCLHFCQUFBLEdBQXVCLFNBQUMsSUFBRDtBQUNyQixRQUFBO0lBQUEsSUFBTyxZQUFQO01BQ0UsS0FBQSxHQUFRLElBQUMsQ0FBQSxRQUFELENBQUE7TUFDUixJQUFBLEdBQ0U7UUFBQSxPQUFBLEVBQVMsWUFBWSxDQUFDLE1BQU0sQ0FBQyxNQUE3QjtRQUNBLEtBQUEsRUFBTyxLQURQO1FBSEo7O0lBS0EsQ0FBQSxDQUFFLDhCQUFGLENBQWlDLENBQUMsSUFBbEMsQ0FBQTtJQUVBLGtCQUFBLEdBQXFCLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxHQUFEO0FBQ25CLFlBQUE7UUFEcUIsZUFBSztRQUMxQixLQUFDLENBQUEsU0FBUyxDQUFDLEdBQVgsQ0FBZSxJQUFJLENBQUMsT0FBcEI7UUFDQSxJQUFBLEdBQU8sQ0FBQyxDQUFDLE1BQUYsQ0FBUyxJQUFULEVBQWU7VUFBQyxLQUFBLEdBQUQ7VUFBTSxLQUFBLEdBQU47VUFBVyxnQkFBQSxFQUFrQixJQUE3QjtTQUFmO1FBQ1AsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLGtDQUF6QixFQUE2RDtVQUFDLEtBQUEsR0FBRDtVQUFNLEtBQUEsR0FBTjtTQUE3RDtRQUVBLFFBQVEsQ0FBQyxrQkFBVCxDQUE0QixvQkFBNUIsRUFBa0QsSUFBbEQ7ZUFDQSxLQUFDLENBQUEsc0JBQUQsQ0FBd0IsSUFBeEI7TUFObUI7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO0lBUXJCLGdCQUFBLEdBQW1CLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxHQUFEO1FBQ2pCLEtBQUMsQ0FBQSx1QkFBRCxDQUFBO1FBQ0EsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLGdDQUF6QixFQUEyRCxHQUEzRDtRQUNBLEtBQUMsQ0FBQSxhQUFhLENBQUMsd0JBQWYsQ0FBd0Msa0JBQXhDO1FBQ0EsS0FBQyxDQUFBLGdCQUFELENBQUE7ZUFDQSxLQUFDLENBQUEsVUFBRCxDQUFZLEtBQVo7TUFMaUI7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO1dBT25CLE9BQU8sQ0FBQyxLQUFLLENBQUMscUJBQWQsQ0FBb0Msa0JBQXBDLEVBQXdELGdCQUF4RDtFQXZCcUI7OzBCQXlCdkIsZUFBQSxHQUFpQixTQUFDLE9BQUQ7QUFDZixRQUFBOztNQURnQixVQUFVOztJQUN6Qix5QkFBRCxFQUFVLDJDQUFWLEVBQTRCLGlCQUE1QixFQUFpQyxpQkFBakMsRUFBc0MseUNBQXRDLEVBQXVEO0lBQ3ZELE9BQUEsR0FBVTtNQUNSLFNBQUEsT0FEUTtNQUVSLFFBQUEsRUFBVTtRQUNSLEtBQUEsR0FEUTtRQUVSLEtBQUEsR0FGUTtPQUZGO01BTVIsa0JBQUEsZ0JBTlE7TUFPUixPQUFBLEVBQVMsSUFBQyxDQUFBLE9BUEY7TUFRUixpQkFBQSxlQVJRO01BU1IsZUFBQSxhQVRROztJQVdWLElBQUEsQ0FBQSxDQUFPLGVBQUEsSUFBbUIsYUFBMUIsQ0FBQTtNQUNFLE9BQUEsR0FBVSxDQUFDLENBQUMsTUFBRixDQUFTLEVBQVQsRUFBYSxPQUFiLEVBQXNCO1FBQzlCLGVBQUEsRUFBaUIsSUFBQyxDQUFBLGVBRFk7UUFFOUIsYUFBQSxFQUFlLElBQUMsQ0FBQSxhQUZjO09BQXRCLEVBRFo7O0lBTUEsSUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSO01BQ0UsSUFBQyxDQUFBLFFBQUQsR0FBZ0IsSUFBQSxRQUFBLENBQUEsRUFEbEI7O1dBRUEsSUFBQyxDQUFBLFFBQVEsQ0FBQyxPQUFWLENBQWtCLE9BQWxCO0VBckJlOzswQkF3QmpCLHNCQUFBLEdBQXdCLFNBQUMsSUFBRDtBQUN0QixRQUFBO0lBQUMsc0JBQUQsRUFBVTtJQUNWLE9BQU8sQ0FBQyxLQUFLLENBQUMsVUFBZCxDQUF5Qiw0Q0FBekIsRUFBdUU7TUFBQyxPQUFBLEtBQUQ7TUFBUSxTQUFBLE9BQVI7S0FBdkU7SUFDQSxJQUFpQyxJQUFDLENBQUEsT0FBRCxLQUFZLElBQTdDO01BQUEsSUFBQSxHQUFPLGdCQUFBLENBQWlCLElBQWpCLEVBQVA7O0lBQ0EsSUFBQSxHQUFPLENBQUMsQ0FBQyxNQUFGLENBQVMsRUFBVCxFQUFhLElBQWIsRUFBbUI7TUFDeEIsZUFBQSxFQUFpQixJQUFDLENBQUEsZUFETTtNQUV4QixhQUFBLEVBQWUsSUFBQyxDQUFBLGFBRlE7S0FBbkI7V0FJSCxJQUFBLFFBQUEsQ0FBQSxDQUFVLENBQUMsb0JBQVgsQ0FBZ0MsSUFBaEM7RUFSa0I7OzBCQVV4QixlQUFBLEdBQWlCLFNBQUMsR0FBRDtBQUNmLFFBQUE7SUFEaUIsdUJBQVMsbUJBQU8saUNBQWM7SUFDL0MsUUFBUSxDQUFDLFlBQVQsQ0FBc0IsWUFBWSxDQUFDLEdBQWIsR0FBbUIsR0FBbkIsR0FBeUIsWUFBWSxDQUFDLEdBQTVEOztNQUNBLFFBQVM7O0lBQ1QsSUFBRyxnQ0FBSDtNQUNFLE9BQUEsR0FBVSxZQUFZLENBQUMsWUFEekI7O0lBRUEsZUFBQSxHQUFrQjtJQUVsQixJQUFHLGdCQUFIO01BRUUsT0FBQSxHQUFVLFlBQVksQ0FBQyxNQUFNLENBQUM7TUFDOUIsZUFBQSxHQUFrQiwwQ0FIcEI7O0lBS0EsWUFBWSxDQUFDLE9BQWIsR0FBdUIsWUFBWSxDQUFDLFlBQWIsR0FBNEI7SUFDbkQsUUFBUSxDQUFDLGtCQUFULENBQTRCLFlBQTVCO0lBQ0EsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLGVBQXpCLEVBQTBDO01BQUMsU0FBQSxPQUFEO01BQVUsY0FBQSxZQUFWO01BQXdCLE9BQUEsS0FBeEI7S0FBMUM7SUFFQSxJQUFHLENBQUMsSUFBQSxHQUFPLFlBQUEsSUFBZ0Isb0JBQUEsQ0FBQSxDQUF4QixDQUFIO01BQ0UsSUFBQSxHQUFPLENBQUMsQ0FBQyxJQUFGLENBQU8sSUFBUCxFQUFhLENBQUMsYUFBRCxFQUFnQixjQUFoQixFQUFnQyxPQUFoQyxDQUFiO01BQ1AsbUJBQUEsR0FBc0IsQ0FBQyxDQUFDLElBQUYsQ0FBTyxJQUFQLEVBQWEsS0FBYixFQUFvQixLQUFwQixFQUEyQixpQkFBM0IsRUFBOEMsVUFBOUMsRUFBMEQsU0FBMUQ7TUFDdEIsbUJBQUEsR0FBc0IsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxtQkFBVCxFQUE4QjtRQUFDLFNBQUEsRUFBZSxJQUFBLElBQUEsQ0FBQSxDQUFNLENBQUMsT0FBUCxDQUFBLENBQWhCO09BQTlCO01BQ3RCLElBQUEsR0FBTyxDQUFDLENBQUMsTUFBRixDQUFTLElBQVQsRUFBZTtRQUFDLE9BQUEsS0FBRDtRQUFRLFlBQUEsRUFBYyxJQUF0QjtPQUFmO01BQ1Asb0JBQUEsQ0FBcUIsZ0JBQXJCLEVBQXVDLG1CQUF2QzthQUNBLElBQUMsQ0FBQSxVQUFELENBQVksSUFBWixFQU5GOztFQWhCZTs7MEJBd0JqQixhQUFBLEdBQWUsU0FBQyxHQUFEO0FBQ2IsUUFBQTtJQURlLHVCQUFTLHFCQUFRO0lBQ2hDLElBQUMsQ0FBQSxnQkFBRCxDQUFBO0lBQ0EsSUFBQyxDQUFBLFVBQUQsQ0FBWSxLQUFaO0lBQ0EsSUFBVSxNQUFBLEtBQVUsT0FBcEI7QUFBQSxhQUFBOztJQUVBLElBQUcsTUFBQSxLQUFVLGNBQWI7TUFDRSxJQUFDLENBQUEsYUFBYSxDQUFDLHVCQUFmLENBQXVDLE9BQXZDLEVBREY7S0FBQSxNQUVLLElBQUcsTUFBQSxLQUFVLGFBQWI7TUFDSCxJQUFDLENBQUEsYUFBYSxDQUFDLHdCQUFmLENBQXdDLE9BQXhDLEVBREc7O1dBR0wsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLG1DQUF6QixFQUE4RDtNQUFDLFNBQUEsT0FBRDtNQUFVLE1BQUEsSUFBVjtLQUE5RDtFQVZhOzswQkFnQmYsVUFBQSxHQUFZLFNBQUMsSUFBRDtBQUNWLFFBQUE7SUFBQyxzQ0FBRCxFQUFrQix3QkFBbEIsRUFBNEI7SUFDNUIsSUFBQSxDQUFBLENBQU8seUJBQUEsSUFBb0Isa0JBQTNCLENBQUE7TUFDRSxJQUFDLENBQUEsVUFBRCxDQUFZLEtBQVo7QUFDQSxhQUZGOztJQUlBLElBQUcsZUFBQSxJQUFvQixDQUFJLFFBQTNCO01BQ0UsUUFBQSxHQUFXLGdCQURiOztJQUlBLGNBQUEsQ0FBZTtNQUFBLFFBQUEsRUFBVSxRQUFWO0tBQWY7SUFHQyxzQkFBRCxFQUFVO0lBQ1YsV0FBQSxHQUFpQixLQUFILEdBQ1QsWUFBSCxHQUFxQiw2QkFBckIsR0FBd0QsZ0NBRDVDLEdBR1o7SUFDRixPQUFPLENBQUMsS0FBSyxDQUFDLFVBQWQsQ0FBeUIsV0FBekIsRUFBc0M7TUFBQyxTQUFBLE9BQUQ7TUFBVSxPQUFBLEtBQVY7S0FBdEM7SUFFQSxNQUFBLEdBQVMsc0JBQUEsQ0FBdUIsSUFBdkIsQ0FBQSxJQUNQLG9CQUFBLENBQXFCLFFBQXJCLEVBQStCLElBQS9CLEVBQXFDLEtBQXJDLENBRE8sSUFFUCxZQUFBLENBQWEsUUFBYixFQUF1QixDQUFDLENBQUMsSUFBRixDQUFPLElBQVAsRUFBYSxpQkFBYixDQUF2QjtJQUVGLE9BQU8sQ0FBQyxpQkFBUixDQUEwQixNQUExQjtFQXhCVSJ9
